export default "__VITE_ASSET__DefKJojx__"